<template>
  <!-- 抱怨单闭环确认 -->
  <h-inspection-page :title="h_i18n('402e34f03269c71f61246ceb8119b65d')" @inspection-update="inspectionUpdate">
    <inspection-header :title="h_i18n('bc89a15ad1b8f1e18a2a620a529b7dc7')" title-height="80px" styles="padding: 0 18px;">
      <template #title>
        <div style="flex: 1;display: flex; flex-direction: column; justify-content: space-evenly;">
          <h-p :title="h_i18n('4850ea222f13bd23bec1cdace19cb633')" align="left" style="margin-left: 10px">0083001F03A</h-p>
          <h-p :title="h_i18n('f3737dbfae61193590bd513df85ff250')" align="left" style="margin-left: 10px">{{ data.form.complainCode }}</h-p>
        </div>
      </template>
      <template #body>
        <tr>
          <h-td :title="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" colspan="2">{{ data.form.supplyCode }}</h-td>
          <h-td :title="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" colspan="2">{{ data.form.supplyName }}</h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('b060eca2b49819ee8ccebe9df36f3a2c')" colspan="2">{{ data.form.complainPropertyName }}</h-td>
          <h-td :title="h_i18n('a0ecbfa1e4cdb310961027f6ab4083dd')" colspan="2">{{ data.form.complainTypeName }}</h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('03490f3868798323211aa633194df2c1')" colspan="2">{{ data.form.happenSybName }}</h-td>
          <h-td :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" colspan="2">{{ data.form.mtlNo }}</h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" colspan="2">{{ data.form.mtlName }}</h-td>
          <h-td :title="h_i18n('fc889bb1c8d1c8190d64beb59341820b')" colspan="2">{{ data.form.claimMoney }} <span v-if="data.form.claimMoney">{{ h_i18n('c16655df815cf59b03075baa5999a2bf') }}</span></h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('a8e450d03efd4f33232169538abcec3e')" colspan="2">{{ data.form.happenNodeName }}</h-td>
          <h-td :title="h_i18n('13f7745f1c4f6c0fe0335ba69d87f53e')" colspan="2">{{ time(data.form.happenDate, 3) }}</h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('318fac0104c51cb87071ef7d581dd75c')" colspan="5">{{ data.form.complainDescription }}</h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('9790cf50803f2dcecf21ab335cf53ac3')" colspan="5">
            <div style="color: #165dff; font-size: 14px; cursor: pointer" @click="handleFile(data.form.complainFileUuid, data.form.complainFileName)">
              {{ data.form.complainFileName }}
            </div>
          </h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('b52322e39e0214deef7d2b8515e9dd92')" colspan="2">{{ data.form.rectificationRequire }}</h-td>
          <h-td :title="h_i18n('9947fc5342d994ab21610c7a02fb120e')" colspan="2">{{ time(data.form.rectificationTime, 3) }}</h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('2e309212ea3cd4c4ac5c5810e8737cec')" colspan="2">{{ data.form.isrtRoleName }}</h-td>
          <h-td :title="h_i18n('0039880117c13787732d259f5bc9f7f5')" colspan="2">{{ time(data.form.isrtDate, 6) }}</h-td>
        </tr>
        <tr>
          <h-td :title="h_i18n('5960f97b2f81462565de62e52ba9ad1d')" colspan="5">*</h-td>
        </tr>
      </template>
    </inspection-header>
    <div style="margin: 10px; text-align: center">
      <h-button type="default" size="small" @click="proxy.closeWindow()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
    </div>
  </h-inspection-page>
</template>
<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { reactive, getCurrentInstance, onMounted } from 'vue';
import { useRoute } from 'vue-router';

const { proxy } = getCurrentInstance();
const route = useRoute();

const data = reactive({
  complainCode: '', // 抱怨单
  form: {},

  sybAllList: [], // 共产小微列表
  activeName: 'first',
  group: []
});

onMounted(() => {
  if (route.query) {
    data.form.supplyCode = route.query.supplyCode;
    data.form.supplyName = route.query.supplyName;
    data.form.name = route.query.name;
    data.form.nickName = route.query.nickName;
    data.name = route.query.name;
    data.nickName = route.query.nickName;
    data.complainCode = route.query.complainCode;
    window.getItemName = route.query.name;
    window.getItemNickName = route.query.nickName;
  }
  getSybList();
  getInfo();
});

const handleFile = (url, name) => {
  if (url.includes('mkhl/bukl/')) {
    if (url.includes('http')) {
      url = url.split('readFile/')[1];
    }
    console.log(url);
    proxy
      .$http({
        method: 'get',
        url: '/base/fileDownload/downloadFile',
        params: {
          filePath: url
        },
        responseType: 'blob'
      })
      .then(res => {
        if (res.status == 200) {
          let blob = new Blob([res.data], {
            type: 'application/vnd.ms-excel'
          }); // 文件流
          let blobUrl = URL.createObjectURL(blob);
          const link = document.createElement('a'); //模拟a链接，不支持低版本ie
          link.download = name;
          link.style.display = 'none';
          link.href = blobUrl;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }
      });
  } else {
    proxy.startLoading(h_i18n('8ffe8dae6d15a5be77490834bff8d28b'));
    proxy.httpFile(
      {
        method: 'get',
        url: '/base/fileDownload/downloadFile?filePath=' + url,
        headers: { 'content-type': 'application/json' }
      },
      name
    );
  }
};

// 传高度
const inspectionUpdate = () => {
  proxy.postThisPageHeight();
};

const getInfo = () => {
  proxy
    .$http({
      method: 'post',
      url: '/base/complainOld/listPage',
      headers: { 'content-type': 'application/json' },
      data: {
        sybId:"",
        complainProperty:"",
        complainType:"",
        beginDateOne:"",
        endDateOne:"",
        supplyCode:route.query.supplyCode,
        pageNo:1,
        flag:"sqm",
        queryFlag:"sqm",
        complainId: route.query.complainId,
        name: route.query.name,
        nickName: route.query.nickName
      }
    })
    .then(res => {
      data.form = res.data.data.records.length > 0 ? res.data.data.records[0] : {};
      setTimeout(() => {
        inspectionUpdate();
      });
    });
};

// 获取工厂小微
const getSybList = () => {
  proxy
    .$http({
      method: 'get',
      url: '/base/basicData/selectFactoryList',
      headers: { 'content-type': 'application/json' },
      params: {
        userName: data.name,
        name: data.name,
        nickName: data.nickName
      }
    })
    .then(res => {
      data.sybAllList = res.data;
    });
};
</script>

<style lang="scss" scoped>
:deep(.el-textarea) {
  .el-textarea__inner {
    height: auto;
    padding: 5px;
  }
}

:deep(.el-input-group__append) {
  height: 32px;
}

.btnBox {
  padding: 20px;
}

.h-hwork-form-header {
  padding: 0;
}

:deep(.haier-table-header--right) {
  position: unset !important;
}

.haier-td {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 4px 10px;
  font-size: 14px;
  height: 35px;
  color: #666;
}

.haier-cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.haier-text-right {
  text-align: right;
}
</style>